<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-user-requests">
  <div class="org-admin-user-requests--layout">
    <app-org-admin-sidebar class="org-admin-user-requests--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-user-requests--content">
      <app-page-header></app-page-header>
      <div class="user-requests-container">
        <!-- Filter Panel -->
        <app-filter-panel
          [fields]="filterFields"
          [defaultExpanded]="false"
          (filterChange)="onFilterChange($event)"
          (clearFilters)="onClearFilters()"
        ></app-filter-panel>

        <!-- Custom Tabs -->
        <div class="custom-tabs">
          <div class="tabs-header">
            <div class="tabs-header__tabs">
              <button 
                *ngFor="let tab of tabs; let i = index"
                class="tab-button"
                [class.active]="activeTabIndex === i"
                (click)="onTabChange(i)"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tab-icon" [innerHTML]="tab.icon"></svg>
                <span>{{ tab.label }}</span>
              </button>
            </div>

            <button
              type="button"
              class="toolbar-export-btn"
              aria-label="Export table"
              (click)="onExport()"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg>
              <span>Export</span>
            </button>
          </div>

          <div class="tabs-content">
            <!-- Join Requests Tab Content -->
            <div class="tab-panel" *ngIf="activeTabIndex === 0">
              <app-join-organisation-request
                #joinOrgRequests
                [filters]="currentFilters"
                [showExportButton]="false"
              ></app-join-organisation-request>
            </div>

            <!-- Role Upgradation Tab Content -->
            <div class="tab-panel" *ngIf="activeTabIndex === 1">
              <app-role-upgradation-request
                #roleUpgradeRequests
                [filters]="currentFilters"
                [showExportButton]="false"
              ></app-role-upgradation-request>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
